import React, { useEffect, useState } from 'react';
import {
    HeaderRow,
    Subtle,
} from './DevicesUnconfiguredListStyles';
import { ActionsCell, IconButton } from '../../../../components/Table';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';
import Button from '../../../../components/Button';
import { deleteUnconfiguredDevice, getUnconfiguredDevices } from '../../../../services/unconfiguredDevicesService';
import { UnconfiguredDevice } from '../../../../types/unconfiguredDevices.types';

const DevicesUnconfiguredList: React.FC = () => {
    const [items, setItems] = useState<UnconfiguredDevice[]>([]);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const load = async () => {
        try {
            setLoading(true);
            setErrorMsg('');

            const res = await getUnconfiguredDevices();

            setItems(res);
        } catch (e) {
            console.error(e);
            setErrorMsg('Erro ao buscar devices não configurados.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        void load();
    }, []);

    const handleCopy = async (value: string) => {
        try {
            await navigator.clipboard.writeText(value);
        } catch (e) {
            console.error(e);
            alert('Não foi possível copiar. Seu navegador pode ter bloqueado.');
        }
    };

    const handleDelete = async (id: string, serialNumber: string) => {
        const ok = window.confirm(`Tem certeza que deseja deletar o device "${serialNumber}"?`);
        if (!ok) return;

        try {
            setLoading(true);
            await deleteUnconfiguredDevice(id);
            setItems((prev) => prev.filter((x) => x.id !== id));
        } catch (e) {
            console.error(e);
            alert('Erro ao deletar.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <HeaderRow>
                <Subtle>Mostrando {items.length} device(s) não configurado(s)</Subtle>
                <div style={{ display: 'flex' }}>
                    <Button title={loading ? 'Atualizando...' : 'Atualizar'} onClick={load} disabled={loading} />
                </div>
            </HeaderRow>

            {errorMsg && <Subtle style={{ color: '#d00' }}>{errorMsg}</Subtle>}

            <TableContainer component={Paper} sx={{ overflowX: 'auto', marginTop: '16px' }}>
                <Table sx={{ minWidth: 650 }} aria-label="unconfigured devices table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>Serial number</TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }} align="right">Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items.length === 0 && !loading ? (
                            <TableRow>
                                <TableCell colSpan={2} align="center">Nenhum device não configurado encontrado.</TableCell>
                            </TableRow>
                        ) : (
                            items.map((item) => (
                                <TableRow key={item.id} hover>
                                    <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                                        {item.serialNumber}
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }} align="right">
                                        <ActionsCell style={{ justifyContent: 'flex-end' }}>
                                            <IconButton type="button" onClick={() => handleCopy(item.serialNumber)} title="Copiar serial number">
                                                Copiar
                                            </IconButton>
                                            <IconButton
                                                type="button"
                                                onClick={() => handleDelete(item.id, item.serialNumber)}
                                                title="Deletar"
                                                $danger
                                            >
                                                Deletar
                                            </IconButton>
                                        </ActionsCell>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default DevicesUnconfiguredList;
